import { axiosInstance } from "./config";

const BASE_URL = "/branch";

export const getAllBranches = () =>
  axiosInstance.get(`${BASE_URL}/all`);

export const createBranch = (data) =>
  axiosInstance.post(`${BASE_URL}/create`, data);

export const getMyBranch = async () => {
  const res = await axiosInstance.get(`${BASE_URL}/me`);
  return res.data;
};

export const deleteBranch = (id) =>
  axiosInstance.delete(`${BASE_URL}/${id}`);

export const updateBranch = (id, data) =>
  axiosInstance.put(`${BASE_URL}/${id}`, data);
